'use strict'
export const D2C_TRANSFERED_FILES_REQUEST = "D2C_TRANSFERED_FILES_REQUEST";
export const D2C_TRANSFERED_FILES_SUCCESS = "D2C_TRANSFERED_FILES_SUCCESS";
export const D2C_TRANSFERED_FILES_FAILURE = "D2C_TRANSFERED_FILES_FAILURE";
export const D2C_TRANSFERED_FILES_GET_PAGE_SUCCESS = "D2C_TRANSFERED_FILES_GET_PAGE_SUCCESS";
export const D2C_FILES_FROM_SERVICE_BUS = "D2C_FILES_FROM_SERVICE_BUS";
export const UPDATE_FILE_LIST_ON_RETRIEVE_FILES = "UPDATE_FILE_LIST_ON_RETRIEVE_FILES";
export const D2C_TRANSFERED_FILES_DOWNLOAD_REQUEST = "D2C_TRANSFERED_FILES_DOWNLOAD_REQUEST";
export const D2C_TRANSFERED_FILES_DOWNLOAD_SUCCESS = "D2C_TRANSFERED_FILES_DOWNLOAD_SUCCESS";
export const D2C_TRANSFERED_FILES_DOWNLOAD_FAILURE = "D2C_TRANSFERED_FILES_DOWNLOAD_FAILURE";
export const D2C_TRANSFERED_FILES_DOWNLOAD_RESET = "D2C_TRANSFERED_FILES_DOWNLOAD_RESET";
export const D2C_TRANSFERED_FILES_DOWNLOAD_UPDATE = "D2C_TRANSFERED_FILES_DOWNLOAD_UPDATE";
export const D2C_TRANSFERED_FILES_DEVICE_STATE_ADD = "D2C_TRANSFERED_FILES_DEVICE_STATE_ADD";
export const D2C_TRANSFERED_FILES_DEVICE_STATE_REMOVE = "D2C_TRANSFERED_FILES_DEVICE_STATE_REMOVE";